import { Component, Input } from '@angular/core';

import { Subject, combineLatest } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

import { FiltrableSelectComponentBase } from './filterable-select.component-base';

@Component({
	selector: 'extended-filterable-select',
	templateUrl: 'extended-filterable-select.html',
	styleUrls: ['extended-filterable-select.css'],
})
export class ExtendedFilterableSelectComponent extends FiltrableSelectComponentBase<any> {
	// Etat montrant sur le panneau de suggestion est ouvert ou non
	panelOpen: boolean = false;

	// Valeur actuelle de la categorie
	selectedCategory: any = null;

	// Observable pour la categorie
	categorySubject$ = new Subject<any>();

	constructor() {
		super();

		let categoryFilter$ = this.categorySubject$.pipe(
			startWith(null)
		);

		// Definit comment le filtrage est effectue
		this.filteredItems$ = combineLatest([this.textFilter$, categoryFilter$, this.list$, this.reset$]).pipe(
			map(
				([textFilter, category, list, _]) => {
					if (!list) {
						return [];
					}
					
					if (!textFilter && (category === null || category === undefined)) {
						return [...this.list];
					}
	
					let normalizedFilter = this.normalizeValue(textFilter);
					return list.filter(
						(item) => {
							if (category || category === 0) {
								const inCategory = this.categoryChecker(item, category);
								if (!inCategory) {
									return false;
								}
							}
	
							let label: string | undefined = this.getLabel(item);
							let normalizedLabel: string = this.normalizeValue(label);
							return normalizedLabel.includes(normalizedFilter);
						}
					);
				}
			)
		);
	}

	// (Optionel) La class de style a appliquer au composant de saisie
	@Input() inputClass: string = 'form-control';

	// (Optionel) La class de style a appliquer au composant de selection de categorie
	@Input() selectClass: string = 'form-control';

	// La fonction a utiliser pour obtenir le libelle d'une categorie
	@Input() categoryLabelGetter!: (item: any) => string;

	// Fonction simplifiant l'utilisation du cagtegoryLabelGetter dans l'interface
	getCategoryLabel: (item: any) => string = (item) => (item || item === 0) ? this.categoryLabelGetter(item) : '';

	// Le label de l'option "tous" dans la liste des categories (null = pas d'option "Tous")
	@Input() wildcardCategoryLabel: string | null = null;

	// La liste des categories
	private _categoryList!: any;
	@Input() set categoryList(list: any[]) {
		this._categoryList = list;
		this.selectedCategory = null;
		this.categorySubject$.next(null);
	}
	get categoryList(): any[] {
		return this._categoryList;
	}

	@Input() categoryChecker!: (item: any, category: any) => boolean;

	@Input() allowsSelectionCancel: boolean = true;

	// (Optionel) Icone du bouton d'action	
	@Input() actionIconClass: string = 'fa-minus-circle';

	// (Optionel) Title du bouton d'action
	@Input() actionTitle: string = 'Effacer';

	// (Optionel) Function declenchee par le bouton d'action
	@Input() actionFunction: () => void = this.onSelectionCancel;

	/////////////////////////////////////
	// Gestion des actions utilisateur //
	///////////////////////////////////// 

	onSelectFocus() {
		// Quand l'utilisateur met le focus sur la liste des categorie, il faut s'assurer que la drop-down d'automcompletion s'affiche/reste ouverte
		this.ensureDropdownOpen();
	}

	onCategoryChange(category: any) {
		this.selectedCategory = category;
		
		// Quand l'utilisateur change la categorie, il faut refaire le filtrage
		this.categorySubject$.next(category);
	}

	onSelectionCancel() {
		if (!this.disabled) {
			this._selectedItem = null;
			this.filterInput.setValue(null);
			this.selectedItemChange.emit(null);
		}
	}
}